import React, { useState } from 'react';
import { Select, AutoComplete } from 'antd';
import { DeleteOutlined, PlusOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';

const RelativesInfo = ({ relativesData, setRelativesData, selectors }) => {
  
  const [showRelativesModal, setShowRelativesModal] = useState(false);
  const [editRelatives, setEditRelatives] = useState(false);
  const [editRelativesIndex, setEditRelativesIndex] = useState(0);
  const [newRelativesData, setNewRelativesData] = useState({
    RelationshipDegree: {
      Name: '',
      UID: ''
    },
    Name: '',
    BirthDate: '',
    BirthPlace_Country: {
      Name: '',
      UID: ''
    },
    Position: '',
    ResidencePlace: '',
    WorkPlace: '',
    Dependent: '',
    IsDisabled: ''
  });  

  const handleRelativesChange = (e, option) => {
    let { name, value, dataset } = typeof e === "string" ? option : e.target;
    const { parent } = dataset;
    if(name === 'BirthDate') value += 'T00:00:00';
    if (parent) {
      if(dataset.uid) {
        setNewRelativesData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                [name]: value,
                UID: dataset.uid
            }
        }));
      } else {
        setNewRelativesData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                [name]: value
            }
        }));
      }
    } else {
        setNewRelativesData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
  };

  const handleBirthPlaceCountryChange = (value) => {
    let parent = 'BirthPlace_Country';
    setNewRelativesData(prevState => ({
        ...prevState,
        [parent]: {
            ...prevState[parent],
            Name: value,
            UID: ''
        }
    }));
  }

  const handleAddRelativesRow = (e) => {
      e.preventDefault();
      if (editRelatives) {
        setRelativesData(prevData => {
            const newData = [...prevData];
            newData[editRelativesIndex] = newRelativesData;
            return newData;
        });
      } else {
        newRelativesData.Deletable = true;
        setRelativesData(prevData => {
            if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
              return [newRelativesData];
            } else {
              return [...prevData, newRelativesData];
            }
        });
      }
      setShowRelativesModal(false);
      setNewRelativesData({
        RelationshipDegree: {
          Name: '',
          UID: ''
        },
        Name: '',
        BirthDate: '',
        BirthPlace_Country: {
          Name: '',
          UID: ''
        },
        Position: '',
        ResidencePlace: '',
        WorkPlace: '',
        Dependent: '',
        IsDisabled: ''
      });
      setEditRelatives(false);
      setEditRelativesIndex(-1);
  };

  const handleRemoveRelativesRow = (index) => {
      setRelativesData(prevData => {
          const newData = [...prevData];
          newData.splice(index, 1);
          return newData;
      });
  };

  const handleCloseRelativesModal = () => {
    setShowRelativesModal(false);
    setNewRelativesData({
      RelationshipDegree: {
        Name: '',
        UID: ''
      },
      Name: '',
      BirthDate: '',
      BirthPlace_Country: {
        Name: '',
        UID: ''
      },
      Position: '',
      ResidencePlace: '',
      WorkPlace: '',
      Dependent: '',
      IsDisabled: ''
    });
    setEditRelatives(false);
    setEditRelativesIndex(-1);
  };

  const isObjectEmpty = (data) => {
    for (const item of data) {
        for (const key in item) {
            if (typeof item[key] === 'object') {
                const subItem = item[key];
                for (const subKey in subItem) {
                    if (subItem[subKey] !== '') {
                        return false;
                    }
                }
            } else if (item[key] !== '') {
                return false;
            }
        }
    }
    return true;
  };

  return (
    <>
      <div className='profile-content'>
        <button type='button' className='addButton' onClick={() => setShowRelativesModal(true)}><PlusOutlined /> Добавить родственника</button>
        {!isObjectEmpty(relativesData) && relativesData.map((rel, index) => (
          <div className={'itemCard'} key={`rel${index}`}>
            <h1>{rel.Name ? rel.Name : 'Не указано'}</h1>
            <p>{rel.RelationshipDegree.Name ? rel.RelationshipDegree.Name : 'Не указано'}</p>
            <div className={'actions'}>
              <button className="btn" onClick={() => {
                setNewRelativesData(rel);
                setEditRelatives(true);
                setEditRelativesIndex(index);
                setShowRelativesModal(true);
              }}><EditOutlined /></button>
              <button className="btn" onClick={() => handleRemoveRelativesRow(index)}><DeleteOutlined /></button>
            </div>
          </div>
        ))}     
        
        {showRelativesModal && (
          <>
              <div className="modal-bg" onClick={() => handleCloseRelativesModal()}></div>
              <div className="modal">
                  <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Сведения о близком родственнике</h4>
                  <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseRelativesModal()} ><CloseOutlined /></button>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td width="40%"><p>Степень родства:</p></td>
                        <td width="60%">
                          <Select
                            size='small'
                            value={newRelativesData.RelationshipDegree.Name ? newRelativesData.RelationshipDegree.Name : undefined}
                            onChange={handleRelativesChange}
                            style={{ width: '100%' }}
                            placeholder="Выберите степень родства"
                            options={selectors.relationshipDegrees}
                            />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Ф.И.О.:</p></td>
                        <td><input type="text" name="Name" value={newRelativesData.Name} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Дата рождения:</p></td>
                        <td><input type="date" name="BirthDate" value={newRelativesData.BirthDate ? newRelativesData.BirthDate.split('T')[0] : ''} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Страна рождения:</p></td>
                        <td>
                          {/* <Select
                            size='small'
                            value={newRelativesData.BirthPlace_Country.Name ? newRelativesData.BirthPlace_Country.Name : undefined}
                            onChange={handleRelativesChange}
                            showSearch
                            style={{ width: '100%' }}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                            filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                            placeholder="Выберите страну"
                            notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                            options={selectors.relBirthPlaceCountries}
                          /> */}
                          <AutoComplete
                            allowClear={true}
                            size='medium'
                            options={selectors.relBirthPlaceCountries}
                            style={{
                                width: '100%',
                            }}
                            value={newRelativesData.BirthPlace_Country.Name}
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                            onSelect={(e, option) => handleRelativesChange(e, option)}
                            onChange={handleBirthPlaceCountryChange}
                            placeholder="Выберите страну"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Должность:</p></td>
                        <td><input type="text" name="Position" value={newRelativesData.Position} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Место работы:</p></td>
                        <td><input type="text" name="WorkPlace" value={newRelativesData.WorkPlace} onChange={handleRelativesChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Адрес:</p></td>
                        <td><input type="text" name="ResidencePlace" value={newRelativesData.ResidencePlace} onChange={handleRelativesChange} /></td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ marginTop: "32px" }}></div>
                  <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={handleAddRelativesRow}>ОК</button>
              </div>
          </>
        )}
      </div>


    
    
    </>
  );
};

export default RelativesInfo;
